import React from 'react'
import DisponibilityItem from './DisponibilityItem'
import Informations from './Informations'

const Disponibility = ({ items }) => {

    return (
        items.map((item, i) => (
            <DisponibilityItem key={`disponibility-${i}`} item={item} />
        ))
    )
}

export default Disponibility